'use strict';
const ThemeV2 = require ('./theme-v2'),
	mergeThemesV2 = require('../theme/merge-themes-v2'),
	themesIndex = require('../themes/index'),
	lineTypes = require('./line-types'),
	nodeConnectionPointX = require('./node-connection-point-x'),
	nodeConnectionPointY = require('./node-connection-point-y'),
	DEFAULT_THEME = new ThemeV2(mergeThemesV2({defaultTheme: themesIndex.default})),
	appendUnderLine = function (connectorCurve, connectorLayout) {


		if (connectorLayout.nodeUnderline) {
			const initialRadius = connectorCurve.initialRadius || 0,
				cornerRadius = Number.isFinite(connectorCurve.cornerRadius) ? connectorCurve.cornerRadius : initialRadius,
				straightUp = initialRadius - cornerRadius,
				halfWidth = connectorLayout.nodeUnderline && (Math.floor(0.5 * Math.abs(connectorLayout.nodeUnderline.to.x - connectorLayout.nodeUnderline.from.x)) - 1);
			if (connectorLayout.nodeUnderline.radiused) {
				connectorCurve.afterArrowD = 'M' + (connectorLayout.nodeUnderline.from.x - connectorLayout.position.left) + ',' + (connectorLayout.nodeUnderline.from.y - connectorLayout.position.top - initialRadius) +
					(straightUp ? `v ${straightUp}` : '') +
					(cornerRadius ? 'q0,' + (cornerRadius) + ' ' + cornerRadius + ',' +  (cornerRadius) : '') +
					' h' + (2 * (halfWidth - cornerRadius)) +
					(cornerRadius ? 'q' + cornerRadius + ',0 ' + cornerRadius + ',' +  (-1 * cornerRadius) : '') +
					(straightUp ? `v -${straightUp}` : '');
			} else {
				connectorCurve.afterArrowD = 'M' + (connectorLayout.nodeUnderline.from.x - connectorLayout.position.left) + ',' + (connectorLayout.nodeUnderline.from.y - connectorLayout.position.top) + ' H' + (connectorLayout.nodeUnderline.to.x - connectorLayout.position.left);
			}

		}
		return connectorCurve;
	},
	appendOverLine = function (connectorCurve, connectorLayout) {
		const initialRadius = connectorCurve.initialRadius || 0,
			cornerRadius = Number.isFinite(connectorCurve.cornerRadius) ? connectorCurve.cornerRadius : initialRadius,
			straightUp = initialRadius - cornerRadius,
			halfWidth = connectorLayout.nodeOverline && (Math.floor(0.5 * Math.abs(connectorLayout.nodeOverline.to.x - connectorLayout.nodeOverline.from.x)) - 1);

		if (connectorLayout.nodeOverline) {
			if (!connectorCurve.afterArrowD) {
				connectorCurve.afterArrowD = 'M' + (connectorLayout.nodeOverline.from.x + halfWidth + 1 - connectorLayout.position.left) + ',' + (connectorLayout.nodeOverline.from.y - connectorLayout.position.top);
			}
			connectorCurve.afterArrowD += 'm' + (-1 * halfWidth) + ',' + initialRadius +
				(straightUp ? `v -${straightUp}` : '') +
				(cornerRadius ? 'q0,' + (-1 * cornerRadius) + ' ' + cornerRadius + ',' +  (-1 * cornerRadius) : '') +
				' h' + (2 * (halfWidth - cornerRadius)) +
				(cornerRadius ? 'q' + cornerRadius + ',0 ' + cornerRadius + ',' +  cornerRadius : '') +
				(straightUp ? `v ${straightUp}` : '');
		}
		return connectorCurve;

	},
	calculateConnectorLayout = function (parent, child, connectorAttr, connectorTheme) {
		const left = Math.min(parent.left, child.left),
			top = Math.min(parent.top, child.top),
			lineWidthAttr = connectorTheme.line.width,
			lineWidth = (Number.isFinite(lineWidthAttr) && lineWidthAttr) || 0,
			halfLineWidth = Math.ceil(lineWidth / 2),
			position = {
				left: left,
				top: top,
				width: Math.max(parent.left + parent.width, child.left + child.width, left + 1) - left,
				height: Math.max(parent.top + parent.height, child.top + child.height, top + 1) - top // overline height!
			},
			from = {
				x: nodeConnectionPointX[connectorTheme.connectionPositionFrom.h](parent, child, connectorTheme.fromInset, connectorTheme),
				y: nodeConnectionPointY[connectorTheme.connectionPositionFrom.v](parent, child, connectorTheme.fromInset, connectorTheme)
			},
			to = {
				x: nodeConnectionPointX[connectorTheme.connectionPositionTo.h](child, parent, connectorTheme.toInset, connectorTheme),
				y: nodeConnectionPointY[connectorTheme.connectionPositionTo.v](child, parent, connectorTheme.toInset, connectorTheme)
			},
			connectorGoingDown = from.y >= to.y;
		let nodeUnderline = false, nodeOverline = false;
		if ((connectorTheme.borderType === 'closest-line' && connectorGoingDown) ||
			connectorTheme.borderType === 'underline' ||
			connectorTheme.borderType === 'underline-radiused'
		) {
			nodeUnderline = {
				radiused: !!(connectorTheme.borderType === 'underline-radiused'),
				from: {
					x: child.left,
					y: child.top + child.height + 1
				},
				to: {
					x: child.left + child.width,
					y: child.top + child.height + 1
				}
			};
		}
		if ((connectorTheme.borderType === 'closest-line' && !connectorGoingDown) || connectorTheme.borderType === 'overline') {
			nodeOverline = {
				from: {
					x: child.left - halfLineWidth,
					y: child.top - halfLineWidth
				},
				to: {
					x: child.left + child.width + halfLineWidth,
					y: child.top - halfLineWidth
				}
			};
			to.y = to.y - lineWidth;
		}
		return {
			from,
			to,
			nodeUnderline: nodeUnderline,
			nodeOverline: nodeOverline,
			minHeight: Math.min(child.height, parent.height),
			position
		};
	},
	// * turning parent-child into left-right so the connectors are
	//   always oriented positively;
	// * converts theme into lines
	// * packaging result into a structure that mapjs/mapsvg understand
	themeConnector = function (parent, child, connectorAttr, themeArg) {
		const theme = themeArg || DEFAULT_THEME,
			connectorTheme = theme.connectorTheme({parent, child, connectorAttr}),
			connectorLayout = calculateConnectorLayout(parent, child, connectorAttr, connectorTheme),
			betweenNodes = lineTypes[connectorTheme.type](connectorLayout, connectorTheme),
			withUnderLine = appendUnderLine(betweenNodes, connectorLayout, connectorTheme),
			result = appendOverLine(withUnderLine, connectorLayout, connectorTheme);
		Object.assign(result, connectorTheme.line, {theme: connectorTheme, position: connectorLayout.position});
		return result;
	};

module.exports = themeConnector;
